import type { TargetareJob } from "@/types/targetare";

export function jobActiv(joburi: TargetareJob[]): TargetareJob | null {
  return (
    joburi.find((j) => j.stare === "programat" || j.stare === "in_curs") ?? null
  );
}

export function descriereRezultatClasificare(rezultat: {
  job_id: number;
  stare: TargetareJob["stare"];
  mesaj?: string;
  jurnal?: string | null;
}): string {
  if (rezultat.stare === "programat") {
    return `Jobul #${rezultat.job_id} rulează în fundal; durează 2–3 minute, pagina se actualizează singură.`;
  }
  if (rezultat.stare === "finalizat") {
    return rezultat.jurnal ?? `Jobul #${rezultat.job_id} s-a încheiat.`;
  }
  if (rezultat.stare === "esuat") {
    return rezultat.jurnal ?? `Jobul #${rezultat.job_id} a eșuat.`;
  }
  return rezultat.mesaj ?? `Jobul #${rezultat.job_id} este deja în curs.`;
}
